import React from 'react';

interface BoardToolbarProps {
  search: string;
  setSearch: (val: string) => void;
  tags: string[];
  selectedTag: string;
  setSelectedTag: (val: string) => void;
  onExport: () => void;
}

export const BoardToolbar: React.FC<BoardToolbarProps> = ({
  search,
  setSearch,
  tags,
  selectedTag,
  setSelectedTag,
  onExport,
}) => {
  return (
    <div className="flex gap-2 items-center mb-4">
      <input
        type="text"
        placeholder="Search cards..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="border rounded px-2 py-1"
      />
      <select
        value={selectedTag}
        onChange={e => setSelectedTag(e.target.value)}
        className="border rounded px-2 py-1"
      >
        <option value="">All Tags</option>
        {tags.map(tag => <option key={tag} value={tag}>{tag}</option>)}
      </select>
      <button className="btn btn-sm" onClick={onExport}>Export Board</button>
    </div>
  );
}; 